import { SetState } from 'zustand';

export interface ILoginSlice {
    currentPage: number,
    setCurrentPage: (n: number) => void;
}

const createLoginSlice = (set: SetState<ILoginSlice>) => ({
  currentPage: 0,
  setCurrentPage: (n: number) => {
    set({ currentPage: n });
  },
});

export default createLoginSlice;
